import { address as types, request as HTTP_REQUEST } from '../../constants/types';
import { requestAxios } from './helpers';
const _request = async (path, dispatch, type = HTTP_REQUEST.GET, body = {}, config = {}) => {
    dispatch(setLoading());
    try {
        const zipcode = body.zipcode !== "" ? parseInt(body.zipcode) : 0;
        const response = await requestAxios(type, path, { ...body, zipcode }, config);
        dispatch(setError(null));
        const { data } = response;
        if (data instanceof Array) dispatch({ type: types.GET, payload: data })
        else if (data instanceof Object) {
            const { addresses } = data;
            if (addresses) return dispatch(addresses)
            else {
                const { address } = data;
                switch (type) {
                    case HTTP_REQUEST.POST: dispatch({ type: types.PUSH, payload: address })
                        break;
                    case HTTP_REQUEST.PUT: dispatch({ type: types.PUT, payload: address })
                        break;
                    case HTTP_REQUEST.DELETE: dispatch({ type: types.DELETE, payload: address })
                        break;
                    default: dispatch({ type: types.ROLE, payload: address })
                        break;
                }
            }
        }
    } catch (error) {
        let { message } = error?.response?.data || error;
        message instanceof Object && (message = error.message)
        dispatch(setError(message))
    }
    dispatch(setLoading());
}
export const setAddress = address => dispatch => {
     address.zipcode = address.zipcode !== "" ? parseInt(address.zipcode) : 0;
    dispatch({
        type: types.ADDRESS,
        payload: address
    });
}
export const setLoading = () => dispatch => {
    dispatch({ type: types.LOADING });
}
export const setError = error => dispatch => {
    dispatch({
        type: types.ERROR,
        payload: error
    });
}
export const listAllAddresses = () => async dispatch => {
    await _request('/address', dispatch);
}
export const findAddressByIdAndUser = addressId => async dispatch => {
    await _request(`/user/address/${addressId}`, dispatch);
}
export const findAddressById = addressId => async dispatch => {
    await _request(`/address/${addressId}`, dispatch);
}
export const listAllAddressByUser = () => async dispatch => {
    await _request('/user/address', dispatch);
}
export const listAllAddressByContain = text => async dispatch => {
    const config = { params: { search: text } };
    await _request('/user/address/search', dispatch, HTTP_REQUEST.GET, null, config);
}
export const registerAdresss = () => async (dispatch, getState) => {
    const { address: { address }, user: { user } } = getState();
    const config = { headers: { token: localStorage.getItem('AUTHORIZATION_TOKEN_BLOG') } };
    await _request('/address', dispatch, HTTP_REQUEST.POST, { ...address, userId: user.id }, config);
}
export const updateAddress = addressId => async (dispatch, getState) => {
    const { address: { address } } = getState();
    await _request(`/user/address/${addressId}`, dispatch, HTTP_REQUEST.PUT, address);
}
export const deleteAddress = addressId => async dispatch => {
    await _request(`/user/address/${addressId}`, dispatch, HTTP_REQUEST.DELETE);
}